import script from "./SideMenuTargetReasons.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuTargetReasons.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuTargetReasons.vue?vue&type=style&index=0&id=65352627&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65352627"]])

export default __exports__